<template>
  <div>
    <div class="OTProgressBar">
      <b-progress :value="progress" class="w-100" v-show="isUploading" variant="success" animated />
    </div>
    <button type="button" class="OTiconBtn" v-show="isClose" aria-label="Close" @click="deleteRow">
      <span class="ot-icon-delete-x" aria-hidden="true"></span>
      <RemoveDocuments
        :job="job"
        :rows="rows"
        :row-number="rowNumber"
        :row="row"
        :deletefiles="fileNames"
        v-model="deleteDocModal"
      />
    </button>
  </div>
</template>
<script>
import RemoveDocuments from "@/components/jobEditing/localDocuments/RemoveDocuments.vue";
import { EventBus } from "@mtm-studio/components/src/lib/eventBus.js";
export default {
  props: ["job", "rows", "row", "rowNumber"],
  data() {
    return {
      isClose: true,
      deleteDocModal: false,
      fileNames: []
    };
  },
  computed: {
    isUploading() {
      if (
        this.row[1] === this.$store.state.localDocumentProgress.fileName &&
        this.$store.state.localDocumentProgress.progress !== 100
      ) {
        this.isClose = false;
        return this.$store.state.localDocumentProgress.uploading;
      } else {
        this.isClose = true;
      }
      return false;
    },
    progress() {
      return this.$store.state.localDocumentProgress.progress;
    }
  },
  components: {
    RemoveDocuments
  },
  methods: {
    deleteRow() {
      this.fileNames = [];
      this.fileNames.push(this.row["1"]);
      this.deleteDocModal = true;
    }
  }
};
</script>

